import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import IntroOverview from './IntroOverview';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const SSDNA3DMPLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#IntroO') {
      setBackI(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#IntroO' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Overview</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> O&nbsp;<br/> V&nbsp;<br/> E&nbsp;<br/> R&nbsp;<br/> V&nbsp;<br/> I&nbsp;<br/> E&nbsp;<br/> W&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0', background: 'transparent'}}>
            <div id='IntroO'>
              <IntroOverview/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default SSDNA3DMPLogic;
